import { render } from "./forms.vue?vue&type=template&id=58c1206e&scoped=true"
import script from "./forms.js?vue&type=script&lang=js"
export * from "./forms.js?vue&type=script&lang=js"

import "./forms.vue?vue&type=style&index=0&id=58c1206e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c1206e"]])

export default __exports__